import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Search.css"; // Ensure CSS is correctly imported

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const SearchBar = ({ onClose }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const searchRef = useRef(null);
  const searchInputRef = useRef(null);
  const navigate = useNavigate();
  
  useEffect(() => {
    if (query.length > 0) {
      const fetchResults = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/product/search/?search=${query}`);
          setResults(response.data);
        } catch (error) {
          console.error("Error fetching search results", error);
        }
      };
      fetchResults();
    } else {
      setResults([]);
    }
  }, [query]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        if (typeof onClose === "function") {
          onClose();
        }else {
          setQuery("");
          setResults([]);
        }
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);
  
  const handleViewDetails = (id) => {
    navigate(`/product-details/${id}`);
    if (typeof onClose === "function") {
      onClose();
    } else {
      setQuery("");
      setResults([]);
    }
  };

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  return (
    <div className="search-container" ref={searchRef}>
      <input
        ref={searchInputRef}
        type="text"
        placeholder="Search..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      {results.length > 0 && (
        <ul className="search-results">
          {results.map((item) => (
            <li key={item.id} className="search-item" onClick={()=>{handleViewDetails(item.id)}}>
              {item.image ? (
                <img src={`https://vastuauraprod.s3.amazonaws.com/django-static/${item.image}`} alt={item.name} className="search-img" />
              ) : (
                <div className="no-image">No Image</div>
              )}
              <span>{item.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchBar;
